import { supabaseClient } from "@/lib/supabase";

/** Secretary user_ids linked to this clinician as owner. */
export async function selectLinkedSecretaryIds(ownerClinicianId: string): Promise<Set<string>> {
    const { data, error } = await supabaseClient
        .from("secretary_owners")
        .select("secretary_id")
        .eq("owner_clinician_id", ownerClinicianId);

    if (error) throw error;
    return new Set((data ?? []).map((row) => row.secretary_id));
}

function isPrivilegedStaff(roles: string[] | null | undefined): boolean {
    if (!roles?.length) return false;
    return roles.some((r) => r === "CLINICIAN" || r === "ADMIN" || r === "MANAGER");
}

function isSecretaryRole(roles: string[] | null | undefined): boolean {
    return Boolean(roles?.includes("SECRETARY"));
}

/**
 * Drop secretaries who are not linked to the viewing clinician.
 * Clinicians, admins, and managers always pass. Pass `skipFilter: true` for super-users.
 */
export function filterStaffBySecretaryOwnership<T extends { user_id: string | null; roles?: string[] | null }>(
    staff: T[],
    linkedSecretaryIds: Set<string>,
    options?: { skipFilter?: boolean }
): T[] {
    if (options?.skipFilter) return staff.filter((person) => Boolean(person.user_id));

    return staff.filter((person) => {
        if (!person.user_id) return false;
        if (isPrivilegedStaff(person.roles)) return true;
        if (isSecretaryRole(person.roles)) return linkedSecretaryIds.has(person.user_id);
        return true;
    });
}
